import { Box, Fade, Flex, HStack, Icon, Link, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { FaCheckCircle, FaStar } from 'react-icons/fa';
import { shallow } from 'zustand/shallow';
import { useUIStore } from '#store';

export default function CheckoutTestimonial() {
  const { testimonials, fetchTestimonials, outing } = useUIStore(
    (state) => ({
      testimonials: state.testimonials,
      fetchTestimonials: state.fetchTestimonials,
      outing: state.outing,
    }),
    shallow
  );

  useEffect(() => {
    if (!testimonials?.length) {
      fetchTestimonials();
    }
  }, [testimonials?.length, fetchTestimonials]);

  const outingId = outing?._id?.toString?.() ?? outing?._id;
  const outingName = (outing?.name || '').toLowerCase();
  const outingSlug = (outing?.slug || '').toLowerCase();

  const forOuting = testimonials?.find((t) => {
    const tid = t.tracker?.outingId?._id?.toString?.() ?? t.tracker?.outingId?._id;
    const tName = (t.tracker?.outingId?.name || '').toLowerCase();
    const tParent = (t.tracker?.outingId?.parent_name || '').toLowerCase();
    if (outingId && tid && String(tid) === String(outingId)) return true;
    if (outingName && (tName === outingName || tParent === outingName)) return true;
    if (outingSlug && tName && tName.includes(outingSlug)) return true;
    return false;
  });

  const testimonial = forOuting ?? testimonials?.[0];
  if (!testimonial) {
    return null;
  }

  const location =
    testimonial.tracker?.outingId?.parent_name ||
    testimonial.tracker?.outingId?.name ||
    '';

  return (
    <Fade in unmountOnExit transition={{ enter: { duration: 0.4 } }}>
      <Link
        href="/testimonials"
        target="_blank"
        rel="noopener noreferrer"
        _hover={{ textDecoration: 'none' }}
        display="block"
      >
        <Box
          p={[2, 4]}
          borderRadius="xl"
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderLeft="4px solid"
          borderLeftColor="brand.500"
          boxShadow="sm"
          _hover={{ boxShadow: 'md' }}
          transition="box-shadow 0.2s"
          cursor="pointer"
        >
        <Flex direction="column" gap={[2, 3]}>
          <HStack spacing={1}>
            {[...Array(5)].map((_, i) => (
              <Icon key={i} as={FaStar} color="yellow.400" boxSize={[2.5, 3]} />
            ))}
          </HStack>
          <Text
            fontSize={['xs', 'sm']}
            color="gray.700"
            lineHeight="tall"
            noOfLines={[2, 3]}
            fontStyle="italic"
          >
            "{testimonial.description}"
          </Text>
          <Flex align="center" gap={[1, 2]} flexWrap="wrap">
            <HStack spacing={1} flexShrink={0}>
              <Text fontWeight="600" fontSize={['xs', 'sm']} color="gray.800">
                {testimonial.name}
              </Text>
              <Icon as={FaCheckCircle} color="green.500" boxSize={[2.5, 3]} />
            </HStack>
            {location && (
              <Text fontSize="xs" color="gray.500" noOfLines={1} display={['none', 'block']}>
                {location}
              </Text>
            )}
          </Flex>
        </Flex>
      </Box>
      </Link>
    </Fade>
  );
}
